
import Vue from 'vue';
import dayjs from 'dayjs';
import { TradingServer } from '@/utils/Api';

export default Vue.extend({
  data () {
    return {
      loading: false,
      dateFields: {
        fromDate: {
          value: dayjs().format('YYYY-MM-DD'),
          datepicker: false
        },
        toDate: {
          value: dayjs().format('YYYY-MM-DD'),
          datepicker: false
        },
      },
      fieldDelimiter: ';',
      lineDelimiter: '\n',
      maxDate: dayjs().format('YYYY-MM-DD'),
      error: ''
    };
  },
  props: {
    value: {
      type: Boolean
    }
  },
  computed: {
    filename (): string {
      return `oct_leads_${this.dateFields.fromDate.value}-${this.dateFields.toDate.value}.csv`;
    }
  },
  methods: {
    async download () {
      try {
        this.loading = true;
        this.error = '';

        const response = await TradingServer<string>({
          url: '/v2/depots/{broker}/leads',
          method: 'GET',
          urlParams: {
            broker: this.$store.getters['BROKER']
          },
          params: {
            'start-date': this.dateFields.fromDate.value,
            'end-date': this.dateFields.toDate.value,
            'fieldDelimiter': this.fieldDelimiter,
            'lineDelimiter': this.lineDelimiter
          }
        });

        if (!response.data) {
          this.error = 'export_dialog_error_no_data';
        } else {
          this.downloadFile(response.data);
        }

      } catch (error) {
        this.error = error.toString();
        throw error;
      } finally {
        this.loading = false;
      }
    },
    downloadFile (data: string) {
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
      element.setAttribute('download', this.filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  }
});
